// var mime = require('mime-types')
import mime from 'mime-types'
import hljs from 'highlight.js';
/*
// tree-shaking:
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
hljs.registerLanguage('javascript', javascript);
*/

// Bootstrap
// https://stackoverflow.com/questions/37452086/what-is-the-best-way-to-load-bootstrap-with-an-es6-import
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';

const SELECTORS = {
    PRINT_DESTINATION_SELECT: '#print-destination-select',
    PRINT_EXTERNALLY_BUTTON: '#print-externally-button',
    PRINT_BUTTON: '#print-button',
    PREVIEW: '#preview',
    FORMATTING: '#formatting',
    FORMATTING_STYLES_WRAPPER: '#formatting-styles',
    FORMATTING_ELEMENT_WRAPPER: '#element-formatter',
    PRINTABLES: '#printables',
}

/**
 * @see https://www.ibm.com/docs/en/cmofm/9.5.0?topic=SSEPCD_9.5.0/com.ibm.ondemand.mp.doc/arsa0449.htm
 */
const PAGE_SIZES = { // TODO: sync with picture-positioner.
    // 210 x 297 mm
    A4: {
        width: 210,
        height: 297
    }
}
const DEFAULT_PAGE_SIZE = PAGE_SIZES.A4

const STYLES = [ // TODO
    {
        css: 'font-size',
        name: 'Font size',
        input: 'pt'
    },
    {
        css: 'font-family',
        name: 'Font',
        input: 'font'
    },
    {
        css: 'color',
        name: 'Font colour',
        input: 'color'
    },
    {
        css: 'line-height',
        name: 'Line height',
        input: 'number' // 1 is normal
    },
    {
        css: 'letter-spacing',
        name: 'Letter spacing',
        input: 'em'
    },
]

const ALLOWED_TYPES = [
    'data', 'id', 'url'
]

const IMAGE_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg'
]
const FETCHABLE_MIME_TYPES = [
    'text/plain',
    'application/json'
]

/**
 * @typedef {(typeof ALLOWED_TYPES)[number] & ('data'|'id'|'url')} Type
 */

/**
 * @param {string} selector
 */
function safeQuerySelector(selector) {
    const element = document.querySelector(selector)
    if (!element) {
        throw new Error(`No element: ${selector}`)
    }
    return element
}

/**
 * @param {string} selector 
 */
function safeQueryHTMLElement(selector) {
    const element = document.querySelector(selector)
    if (!(element instanceof HTMLElement)) {
        throw new Error(`No HTMLElement: ${selector}`)
    }
    return element
}

function setupEvents() {
    // EXTERNAL PRINT
    /*
    // Support once have external print services to link:
    safeQuerySelector(SELECTORS.PRINT_EXTERNALLY_BUTTON).addEventListener('click', function() {
        const destination = safeQuerySelector(SELECTORS.PRINT_DESTINATION_SELECT).value
        // TODO: First convert to data format that is allowed. data formats, text, html would probably need to be done on server.
        // TODO: Send to destination based on set allowed format. API OR affiliate link OR manual.
    })
    */

    // PRINT
    safeQuerySelector(SELECTORS.PRINT_BUTTON).addEventListener('click', function() {
        window.print()
        // printJS(data)
    })
}

function setupPrintables() {
    // TODO: Eventually, use same handling that apps/schema querying on theopenweb.info is going to use for fetch/filter/displaying.
    const printables = [
        {
            identifier: 'test',
            name: 'Test',
            value: 'Test Data'
        }
    ]
    const wrapper = safeQuerySelector(SELECTORS.PRINTABLES)
    printables.forEach(printable => {
        const element = document.createElement('div')
        element.style.float = 'left'
        element.style.padding = '10px'
        element.style.margin = '10px'
        element.style.cursor = 'pointer'
        element.style.border = '1px solid black'
        element.style.borderRadius = '5px'
        element.textContent = printable.value
        element.addEventListener('click', function() {
            const data = element.textContent // For now.
            const Url = new URL(location.href)
            Url.searchParams.set('type', 'data')
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
            Url.searchParams.set('data', `data:text/plain;,${data}`)
            const url = Url.toString()
            window.location.href = url
        })
        wrapper.appendChild(element)
    })
    
}

/**
 * @param {string} uri
 * @param {string} mimeType 
 */
function loadDataUrl(uri, mimeType) {
    const data = dataUriToData(uri)
    if (mimeType === 'text/plain') {
        const div = document.createElement('div')
        div.textContent = data
        return div
    } else if (isCodeMimeType(mimeType)) {
        const html = hljs.highlight(data, { language: mimeType.split('/').pop() || '' }).value
        const div = document.createElement('div')
        div.innerHTML = html
        return div
    } else {
        throw new Error(`Unsupported mime type: ${mimeType}`)
    }
}

/**
 * type:
 * data: Pass data via datauri string.
 * id: Pass data via known id.
 * url: Pass data via url.
 * 
 * data: The data as specified by the type.
 */
async function handleQueryParameters() {
    const url = new URL(location.href)
    const { searchParams } = url
    const data = searchParams.get('data')
    if (!data) {
        // throw new Error('No data')
        console.warn('No data')
        return
    }
    const type = parseType(searchParams.get('type'), data)

    if (type === 'data') {
        const mimeType = getMimeTypeFromDataURI(data) || 'text/plain'
        const loadedData = await loadDataUrl(data, mimeType)
        setPreview(loadedData)
    } else if (type === 'id') {
        // TODO: Create a to-print namespace.
        throw new Error('Not supported')
    } else if (type === 'url') {
        // TODO: fetch and then handle based on type.
        const mimeType = getMimeTypeFromURL(data) || 'text/plain'
        // TODO: url and datauri should be same format for loading. Check.
        const loadedData = await loadUrl(data, mimeType)
        if (!loadedData) throw new Error('No data')
        setPreview(loadedData)
    } else {
        throw new Error(`Unsupported type: ${type}`)
    }
}

/**
 * @param {string | null} type
 * @param {any} data
 * @return {Type}
 */
function parseType(type, data) {
    if (type && ALLOWED_TYPES.includes(type)) {
        return /** @type {Type} */ (type);
    } else if (!type) {
        // NO TYPE
        if (typeof data === 'string' && (data.startsWith('https:') || data.startsWith('http:'))) {
            return 'url'
        } else if (typeof data === 'string' && data.startsWith('data:')) {
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
            return 'data'
        } else if (typeof data === 'string') {
            return 'id'
        } else {
            throw new Error('Could not infer type')
        }
    } else {
        // BAD TYPE
        throw new Error(`Invalid type: ${type}`)
    }
}

/**
 * @param {HTMLElement} element
 */
function setPreview(element) {
    const preview = safeQuerySelector(SELECTORS.PREVIEW)
    preview.innerHTML = ''
    preview.appendChild(element)
}

/**
 * @param {string} dataURI
 */
function getMimeTypeFromDataURI(dataURI) {
    return dataURI.substring(dataURI.indexOf(":")+1, dataURI.indexOf(";"))
}

/**
 * @param {string} url
 */
function getMimeTypeFromURL(url) {
    return mime.lookup(url)
}

/**
 * @param {string} mimeType 
 */
function isCodeMimeType(mimeType) {
    const CODE_MIME_TYPES = [
        'application/json', // ADD MORE WHEN NEEDED.
    ]
    return CODE_MIME_TYPES.includes(mimeType)
}

/**
 * @param {string} mimeType 
 */
function isImageMimeType(mimeType) {
    return IMAGE_MIME_TYPES.includes(mimeType)
}

/**
 * @param {string} html 
 */
function loadHTMLInIframe(html) {
    const iframe = document.createElement('iframe')
    const { contentDocument } = iframe
    if (!contentDocument) throw new Error('Could not access iframe document')
    // contentDocument.innerHTML = html
    contentDocument.body.innerHTML = html
    return iframe
}

/**
 * @param {string} url 
 */
function loadInIframe(url) {
    const iframe = document.createElement('iframe')
    iframe.src = url
    return iframe
}

/**
 * Data support specification:
 * IMAGES(HTML and CANVAS supported images)
 * PDF
 * TEXT(With ability to format)
 * HTML
 * Markdown
 * DATA(json, xml)
 * 
 * @param {string} uri Specified as uri because MAY be a datauri as long as can be loaded in same way as URL.
 * @param {string} mimeType
 */
async function loadUrl(uri, mimeType) {
    if (isImageMimeType(mimeType)) {
        // Preview using img or canvas.
        const img = document.createElement('img')
        img.src = uri
        return img
    } else if (mimeType === 'application/pdf') {
        // Preview using iframe or pdf.js
        const iframe = loadInIframe(uri)
        // TODO: pdf.js
        return iframe
    } else if (mimeType === 'text/html') {
        const iframe = loadHTMLInIframe(uri)
        return iframe
    } else if (FETCHABLE_MIME_TYPES.includes(mimeType)) {
        const text = await (await fetch(uri)).text()
        const element = document.createElement('div')
        element.textContent = text
        return element
    } else {
        throw new Error('Invalid data type')
    }
}

/**
 * @param {HTMLElement} element
 * @param {HTMLElement} formatTarget
 * param {(property: string, value: any) => void} onInputChange
 */
function setupElementFormatter(element, formatTarget) {
    const PREFIX = 'element-formatter-'
    const properties = (element.getAttribute('data-controls') || '').split('|')
    properties.forEach(property => {
        const inputWrapper = document.createElement('div')
        const id = `${PREFIX}${property}`

        // Label
        const label = document.createElement('label')
        label.setAttribute('for', id)
        label.textContent = property
        inputWrapper.appendChild(label)

        // Input
        const input = document.createElement('input')
        input.type = 'text'
        input.addEventListener('change', (ev) => {
            formatTarget.style[property] = input.value
            // onInputChange(property, input.value)
        })
        input.value = formatTarget.style[property]
        inputWrapper.appendChild(input)

        element.appendChild(inputWrapper)
    })
}

function setupFormatter() {
    const element = safeQueryHTMLElement(SELECTORS.FORMATTING_ELEMENT_WRAPPER)
    const formatTarget = safeQueryHTMLElement(SELECTORS.PREVIEW)
    setupElementFormatter(element, formatTarget)
}

/**
* Currently ONLY converts to text. Consider handling mime type and converting to blob when desired.
* @param {string} dataUri
*/
function dataUriToData(dataUri) {
    // https://www.microfocus.com/documentation/enterprise-developer/ed60/ES-WIN/index.html?t=BKCJCJDEFNS009.html
    // ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/
    const afterProtocol = dataUri.slice('data:'.length)
    const [mimeType, afterMimeType] = afterProtocol.split(';')
    const [encoding, rawData] = afterMimeType.split(',')
    const data = (encoding === 'base64') ? atob(rawData) : rawData
    return data
}

function setDefaults() {
    const s = safeQuerySelector(SELECTORS.PREVIEW).style
    const { width, height } = DEFAULT_PAGE_SIZE
    s.width = `${width}mm`
    s.height = `${height}mm`
}

function onLoad() {
    setDefaults()
    handleQueryParameters()
    setupEvents()
    setupPrintables()
    setupFormatter()
}

window.addEventListener('load', onLoad)
